// useMediaQuery.js
import { useEffect, useState } from 'react'

import { useTheme } from 'src/utilities/ThemeContext'

export const useMediaQuery = queryOrBreakpoint => {
  const theme = useTheme()
  let query

  // Check if the input is a full media query string or just a breakpoint name
  if (queryOrBreakpoint.startsWith('(')) {
    query = queryOrBreakpoint
  } else {
    const breakpointValue = theme.breakpoints.values[queryOrBreakpoint]
    query = `(min-width: ${breakpointValue}px)`
  }

  const [matches, setMatches] = useState(false)

  useEffect(() => {
    const media = window.matchMedia(query)
    if (media.matches !== matches) {
      setMatches(media.matches)
    }
    const listener = () => setMatches(media.matches)
    media.addEventListener('change', listener)
    return () => media.removeEventListener('change', listener)
  }, [matches, query])

  return matches
}
